const useBodyScrollLock = () => {
  const body = ref(document?.body)
  const scrollPosition = ref(0)

  const isBodyHasScrollBar = computed(() => body.value?.scrollHeight > window.innerHeight)

  const { isMobile } = useAppBreakpoints()

  const lock = () => {
    if (!body.value) return

    if (isMobile.value) {
      scrollPosition.value = window.pageYOffset || document.documentElement.scrollTop
      body.value.style.overflow = 'hidden'
      body.value.style.position = 'fixed'
      body.value.style.top = `-${scrollPosition.value}px`
      body.value.style.width = '100%'
      return
    }

    if (!isBodyHasScrollBar.value) {
      return
    }

    body.value.style.overflow = 'hidden'
    body.value.style.paddingRight = '15px'
  }

  const unlock = () => {
    if (!body.value) return

    if (isMobile.value) {
      body.value.style.overflow = ''
      body.value.style.position = ''
      body.value.style.top = ''
      body.value.style.width = ''
      window.scrollTo(0, scrollPosition.value)
      return
    }

    if (!isBodyHasScrollBar.value) {
      return
    }

    body.value.style.overflow = 'auto'
    body.value.style.paddingRight = '0'
  }

  return {
    lock,
    unlock,
  }
}

export default useBodyScrollLock
